/**
 * @format
 */
import { api } from '@/scripts/api';

export const PartnerSurveyService = {
    getAll({ accountId, config = {}, context }, signal) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/surveys/${context}/account/${accountId}`;
            const endpoint = api.applyNodeDataParams(service, config);
            api.get(endpoint, signal)
                .then(resolve)
                .catch((error) => {
                    if (!api.isCanceled(error)) {
                        reject(error);
                    }
                });
        });
    },

    getById({ accountId, id, options = {}, context = 'vendor' }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/surveys/${id}/${context}/account/${accountId}`;
            const endpoint = api.applyNodeDataParams(service, options);
            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    getSurveyResults({ accountId, id }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/surveys/${id}/vendor/account/${accountId}/results`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getFieldResults({ accountId, id, fieldId }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/surveys/${id}/vendor/fields/${fieldId}/account/${accountId}/results`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getIndividualSurveyResults({ accountId, id, options = {} }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/surveys/${id}/vendor/account/${accountId}/individuals/results`;
            const endpoint = api.applyNodeDataParams(service, options);
            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    getPartnersSubmissionList({ accountId, id, options = {} }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/surveys/${id}/vendor/account/${accountId}/partners/list`;
            const endpoint = api.applyNodeDataParams(service, options);
            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    getRecipients({ id, accountId }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/surveys/${id}/account/${accountId}/recipients`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    post({ accountId, payload }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/surveys/account/${accountId}`;
            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    postRecipients({ id, accountId, payload }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/surveys/${id}/account/${accountId}/recipients`;
            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    patch({ id, accountId, payload }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/surveys/${id}/account/${accountId}`;
            api.msPatch(service, payload).then(resolve).catch(reject);
        });
    },

    patchRecipients({ id, accountId, payload }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/surveys/${id}/account/${accountId}/recipients`;
            api.msPatch(service, payload).then(resolve).catch(reject);
        });
    },

    delete({ id, accountId }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/surveys/${id}/account/${accountId}`;
            api.delete(service).then(resolve).catch(reject);
        });
    },

    publish({ accountId, payload }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/surveys-access/vendor/account/${accountId}/bulk-edit-access`;
            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    unpublish({ accountId, id }) {
        return new Promise((resolve, reject) => {
            const payload = {
                SurveyId: id,
                ClientIds: [],
            };
            const service = `/ms/surveys/v1/surveys-access/vendor/account/${accountId}/bulk-edit-access`;
            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    autoPublish({ id, accountId }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/surveys-access/surveys/${id}/vendor/account/${accountId}/is-autopublish`;
            api.post(service).then(resolve).catch(reject);
        });
    },

    duplicate({ accountId, payload }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/surveys/account/${accountId}/duplicate-survey`;
            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    getPartnerSurveyReport({ accountId }) {
        const endpoint = `/ms/surveys/v1/surveys/vendor/account/${accountId}/reports/partner-survey`;
        return new Promise((resolve, reject) => {
            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    getPartnerSurveyPDFReportData({ accountId }) {
        const endpoint = `/ms/surveys/v1/surveys/vendor/account/${accountId}/reports/partner-survey/export`;
        return new Promise((resolve, reject) => {
            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    getClients(config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/Clients';

            const endpoint = api.applyODataParams(service, config);

            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    getSharedAssets({ id, accountId, config = {} }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/surveys/v1/surveys-access/surveys/${id}/vendor/account/${accountId}/shared-with`;
            const endpoint = api.applyNodeDataParams(service, config);

            api.get(endpoint).then(resolve).catch(reject);
        });
    },
};
